import {useState} from "react";
import {Button, CircularProgress} from "@mui/material";
import {FiDownload} from "react-icons/fi";
import {exportToCsv} from "../../utils/exportCsv";
import {snackbar} from "../../utils/snackbar";

const ExportCsvButton = ({
  rows = [],
  columns,
  filename = "export",
  fetchRows,
  csvOptions = {},
  label = "Exportar CSV",
  disabled = false,
  ...buttonProps
}) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);

    try {
      const data = fetchRows ? await fetchRows() : rows;
      const result = exportToCsv({rows: data, columns, filename, ...csvOptions});

      if (!result) {
        snackbar.warning("No hay datos para exportar");
        return;
      }

      snackbar.success(`${result.rowCount} registros exportados a ${result.filename}`);
    } catch (error) {
      console.error("Error al exportar a CSV:", error);
      snackbar.error("Error al exportar los datos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <FiDownload />}
      onClick={handleExport}
      disabled={disabled || loading}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};

export default ExportCsvButton;
